import { MediaViewModel } from "../media-model";
import { PriceRuleBase } from "./price-rule.base";

export class PriceRuleModel extends PriceRuleBase {
    public medias: MediaViewModel[];
    public children: PriceRuleModel[];
}
